// 首先加载polyfill以支持旧版浏览器
import './polyfills.js'

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'

// 错误边界组件
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('应用错误:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-red-900 via-red-800 to-red-900 flex items-center justify-center">
          <div className="text-center p-8 bg-white/10 backdrop-blur-xl rounded-3xl border border-red-500/30">
            <h1 className="text-4xl font-bold text-red-400 mb-4">应用错误</h1>
            <p className="text-red-300 mb-4">抱歉，应用出现了错误</p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-red-500 hover:bg-red-600 text-white rounded-lg font-semibold transition-colors"
            >
              重新加载
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

// 应用加载状态
const LoadingScreen = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900/20 to-gray-900 flex items-center justify-center">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-cyan-400 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <h2 className="text-2xl font-bold text-cyan-400 mb-2">STORM 平台</h2>
      <p className="text-gray-300">正在加载应用...</p>
    </div>
  </div>
)

// 主渲染函数
const renderApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'))
  
  // 显示加载屏幕
  root.render(<LoadingScreen />)
  
  // 延迟渲染主应用，确保所有资源加载完成
  setTimeout(() => {
    root.render(
      <React.StrictMode>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </React.StrictMode>
    )
  }, 500)
}

// 初始化应用 - 移除有问题的兼容性检查，因为polyfill已经处理
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderApp)
} else {
  renderApp()
}

// 热重载支持（开发环境）
if (import.meta.hot) {
  import.meta.hot.accept()
}

console.log('✅ 前端应用初始化完成')
